import { format } from 'date-fns';
import { CalendarPlus, CalendarOff } from 'lucide-react';

interface Props {
  artistName: string;
  startIso: string;
  onNewAppointment: () => void;
  onDayOff: () => void;
  onClose: () => void;
}

export default function SlotActionChooser({ artistName, startIso, onNewAppointment, onDayOff, onClose }: Props) {
  const when = format(new Date(startIso), 'EEE d MMM · HH:mm');
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-overlay/80 px-6 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        data-testid="slot-action-chooser"
        className="w-full max-w-sm rounded-xl border border-gold-dim/40 bg-ink-deep p-6 text-cream-soft"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-base font-semibold text-cream">{artistName}</h2>
        <p className="mt-0.5 text-xs text-cream-faint">{when}</p>
        <div className="mt-4 grid gap-2">
          <button
            data-testid="slot-action-appointment"
            className="flex items-center gap-3 rounded-lg border border-cream-faint/20 p-3 text-left hover:border-gold/60"
            onClick={onNewAppointment}
          >
            <CalendarPlus size={18} className="text-gold" />
            <span>
              <span className="block text-sm font-medium text-cream">New appointment</span>
              <span className="block text-xs text-cream-faint">Book a session in this slot</span>
            </span>
          </button>
          <button
            data-testid="slot-action-dayoff"
            className="flex items-center gap-3 rounded-lg border border-cream-faint/20 p-3 text-left hover:border-azure/60"
            onClick={onDayOff}
          >
            <CalendarOff size={18} className="text-azure" />
            <span>
              <span className="block text-sm font-medium text-cream">Day off / RDO</span>
              <span className="block text-xs text-cream-faint">Mark this day off for the artist</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
